import Rete from "rete";
import VuePrintObjectControl from "./PrintObjectControl.vue";

export class PrintObjectControl extends Rete.Control {
  constructor(emitter, key) {
    super(key);
    this.render = "vue";
    this.component = VuePrintObjectControl;
    this.props = { emitter, ikey: key};
  }

  setValue(val) {
    this.vueContext.value = val;
  }
}